import { render, staticRenderFns } from "./Plus.vue?vue&type=template&id=f75d195a&scoped=true&"
import script from "./Plus.vue?vue&type=script&lang=js&"
export * from "./Plus.vue?vue&type=script&lang=js&"
import style0 from "./Plus.vue?vue&type=style&index=0&id=f75d195a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75d195a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default})
